import { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Appointment } from 'pages/Appointment';
import { HsptlzForm } from 'pages/HsptlzForm';
import { KareNote } from 'pages/KareNote';
import { Mebiconn } from 'pages/Mebiconn';
import { MedicalReferral } from 'pages/MedicalReferral';
import NewConfirmation from 'pages/NewConfirmation';
import NewPtAddress from 'pages/NewPtAddress';
import { NonMember } from 'pages/NonMember';
import { Parking } from 'pages/Parking';
import PersonalInfoAgreement from 'pages/PersonalInfoAgreement';
import PtCard from 'pages/PtCard';
import { Receipt } from 'pages/Receipt';
import { CcrcDetail } from 'widgets/Ccrc';

import { getCommonProcessYn } from './api';
import Layout from './ui/Layout';

export const AppRouter = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: 'confirmation/*',
        element: <NewConfirmation />,
      },
      {
        path: 'personalInfoAgree/*',
        element: <PersonalInfoAgreement />,
      },
      {
        path: 'ptcard',
        element: <PtCard />,
      },
      {
        path: 'nonMember',
        element: <NonMember />,
      },
      {
        path: 'newPtAddress',
        element: <NewPtAddress />,
      },
      {
        path: 'mebiconn',
        element: <Mebiconn />,
      },
      {
        path: 'ccrc/detail/*',
        element: <CcrcDetail />,
      },
      {
        path: 'page/appointment',
        element: <Appointment />,
      },
      {
        path: 'medical/referral/*',
        element: <MedicalReferral />,
      },
      {
        path: 'parking/*',
        element: <Parking />,
      },
      {
        path: 'hsptlz/form/*',
        element: <HsptlzForm />,
      },
      {
        path: 'receipt/*',
        element: <Receipt />,
      },
      {
        path: 'karenote/*',
        element: <KareNote />,
      },
    ],
    loader: async () => {
      // 개발 모드에서는 실행되지 않음
      const searchParams = new URLSearchParams(window.location.search);
      const hspId = searchParams.get('hspId');

      if (process.env.REACT_APP_DEPLOY_ENV && !sessionStorage.getItem('commonProcess')) {
        const data = await getCommonProcessYn({ hspId });
        const { commonProcessYn, headerList } = data.data;
        sessionStorage.setItem('commonProcess', JSON.stringify({ commonProcessYn, headerList }));
      }
      return null;
    },
  },
];

export default AppRouter;

